<template>
  <b-container>
    <b-card>
      <canvas ref="hits-chart" width="160" height="90" />
    </b-card>
  </b-container>
</template>

<script>
import _ from 'lodash'
import Chart from 'chart.js'

import chartColors from '@/components/chart_colors.js'

// *****************************************************************************

class GenericChart {
  constructor(el, colnames, title) {
    this.el = el
    this.labels = colnames
    this.title = title
  }
  init() {
    this.real_chart = new Chart(this.el, {
      type: 'bar',
      data: {
        labels: this.labels,
        datasets: [],
      },
      options: {
        responsive: true,
        plugins: {
          datalabels: {
            display: true,
            color: '#000000',
          },
        },
        title: {
          display: true,
          text: this.title,
        },
        legend: {
          display: false,
        },
        scales: {
          yAxes: [
            {
              ticks: {
                suggestedMin: 0,
                // min: 4,
              },
            },
          ],
        },
      },
    })
  }

  update(datasets, colnames) {
    this.labels = colnames
    this.real_chart.data.labels = this.labels
    this.real_chart.data.datasets = datasets
    this.real_chart.update()
  }
}

// *****************************************************************************

export default {
  name: 'BorutaBarChart',
  components: {},
  props: ['project_id', 'tracking_infos', 'colnames', 'title'],
  data() {
    return {
      chart_object: undefined,
      is_mounted: false,
      colors_list: [
        chartColors.blue,
        chartColors.red,
        chartColors.green,
        chartColors.yellow,
        chartColors.orange,
        chartColors.purple,
        chartColors.grey,
        chartColors.indigo,
        chartColors.pink,
        chartColors.teal,
        chartColors.cyan,
      ],
    }
  },
  computed: {
    datasets() {
      return this.build_bar_chart()
    },
    imp_hits() {
      return this.tracking_infos.imp_hits || []
    },
    nb_iters() {
      return this.imp_hits.length
    },
  },
  watch: {
    colnames(nv, ov) {
      if (nv !== ov) {
        this.check_chart(true)
      }
    },
    datasets(nv, ov) {
      this.check_chart()
    },
  },
  mounted() {
    this.check_chart()
  },
  beforeDestroy() {
    this.destroy_chart()
  },
  methods: {
    destroy_chart() {
      if (this.chart_object) {
        this.chart_object.real_chart.destroy()
      }
    },
    color(i) {
      return this.colors_list[i % this.colors_list.length]
    },

    check_chart(reinit = false) {
      if (_.isUndefined(this.chart_object) || reinit) {
        this.destroy_chart()

        this.chart_object = new GenericChart(
          this.$refs['hits-chart'],
          this.colnames,
          this.title
        )
        this.chart_object.init()
      }
      this.chart_object.update(this.datasets, this.colnames)
    },

    build_bar_chart() {
      let total_imp_hits = this.tracking_infos['total_imp_hits'] || []
      let dataset = {
        backgroundColor: _.map(_.range(total_imp_hits.length), this.color),
        data: total_imp_hits,
      }
      let datasets = [dataset]
      return datasets
    },
  },
}
</script>
